import React from 'react';

import clsx from 'clsx';
import PropTypes from 'prop-types';

import { IconDirection } from 'constants/coreDesignSystem';

import { defaultSize, rotationEnum, sizePropsTypes } from './icons.constants';

const DeployIcon = ({ size = defaultSize, direction = IconDirection.UP, className, ...props }) => (
  <svg
    className={clsx(rotationEnum[direction], className)}
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M13.061 20.354C12.475 20.939 11.525 20.939 10.939 20.354L3.293 12.707C3.007 12.421 2.921 11.991 3.076 11.617C3.231 11.244 3.596 11 4 11L8 11L8 5C8 3.895 8.895 3 10 3L14 3C15.105 3 16 3.895 16 5L16 11L20 11C20.404 11 20.769 11.244 20.924 11.617C21.079 11.991 20.993 12.421 20.707 12.707L13.061 20.354ZM12 18.586L17.586 13L15 13C14.448 13 14 12.552 14 12L14 5L10 5L10 12C10 12.552 9.552 13 9 13L6.414 13L12 18.586Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

DeployIcon.propTypes = {
  ...sizePropsTypes,
  direction: PropTypes.oneOf(Object.keys(rotationEnum)),
  className: PropTypes.string,
};

export default DeployIcon;
